import React from 'react';
import OlcDeleteIcon from '~/components/General/OlcDeleteIcon';

const TrashNew = (props) => <OlcDeleteIcon {...props} size={20} sx={{ color: '#ED5C2F' }} />;

export default TrashNew;
